export const blockIconsMapsPersonPinNew = (
	<span className='material-symbols-outlined'>person_pin</span>
);
